module.exports = __webpack_public_path__ + "static/pizza_6-e047e8c37b099037aa3ee7e8beea9293.jpg";